// components
import { Stack, Switch, Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { Dialog } from 'components/shared/index';
import {
  CustomGridCompact12To4ExtraLarge,
  StyledAddWidgetDialogPaper
} from './AddWidgetTile.styles';

// constants
import { iconsMapping } from './TasksList.const';

// hooks
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// types
import { AddWidgetTileProps } from './AddWidgetTile.types';
import {
  StyledRowStackAlignItemsGap,
  StyledRowStackAlignItemsSpaceBetweenGap
} from 'components/shared/Stack/Stack.styles';

export const AddWidgetTile = ({
  data = [],
  hiddenData = [],
  setHiddenData
}: AddWidgetTileProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'qualityMonitor'
  });
  const { t: tCommon } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (key: string) => {
    setHiddenData?.((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  return (
    <>
      <CustomGridCompact12To4ExtraLarge onClick={() => setIsOpen(true)}>
        <Icon type="plus" fontSize="large" />
        <Typography variant="h6" color="inherit">
          {t('addWidget')}
        </Typography>
      </CustomGridCompact12To4ExtraLarge>

      <Dialog
        open={isOpen}
        handleClose={() => setIsOpen(false)}
        title={t('availableWidgets')}
        slots={{
          paper: StyledAddWidgetDialogPaper
        }}
      >
        <Stack gap={1}>
          {data?.map(({ key }) => {
            const enabled = !hiddenData.includes(key);
            return (
              <StyledRowStackAlignItemsSpaceBetweenGap key={key}>
                <StyledRowStackAlignItemsGap>
                  <Icon
                    type={iconsMapping[key]}
                    className="group-icon"
                    fontSize="medium"
                  />
                  <Typography sx={{ lineHeight: 'normal' }}>
                    {tCommon('taskDefinitionsShort')[key]}
                  </Typography>
                </StyledRowStackAlignItemsGap>

                <Switch
                  checked={enabled}
                  onChange={() => handleToggle(key)}
                  slotProps={{
                    input: {
                      'aria-label': `${enabled ? 'Disable' : 'Enable'} ${key}`
                    }
                  }}
                />
              </StyledRowStackAlignItemsSpaceBetweenGap>
            );
          })}
        </Stack>
      </Dialog>
    </>
  );
};
